module.exports = "<div id=\"{{componentName}}\">\r\n  <div id=\"headerContent\">\r\n    <h2 [innerHtml]=\"repartidorName\"></h2><button (click)=\"goHome()\"><img src=\"./assets/images/left-arrow.png\"></button>\r\n  </div>\r\n  <app-totales [title]=\"'TOTALES'\" [totales]=\"totales\"></app-totales>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/uriel/Documents/newspaperReporteador/src/app/components/totales-del-repartidor/totales-del-repartidor.component.html
// module id = ../../../../../src/app/components/totales-del-repartidor/totales-del-repartidor.component.html
// module chunks = main